module.exports = __webpack_public_path__ + "img/logo-white.e2d986a4.png";